<template>
    <v-layout row>
        <v-flex pa-0 xs12 d-inline-flex>
            <v-flex xs11>
                <v-text-field 
                v-model='dateText' 
                :label='label' 
                placeholder=' '
                persistent-hint
                :readonly='setDisabled'
                :class='{"text-no-border" : setDisabled}' />
            </v-flex>
            <v-flex xs1 pt-2 pr-4>
                <v-menu ref='menu' :close-on-content-click='false' v-model='menu' lazy transition='scale-transition' offset-y full-width>
                    <v-icon slot='activator' ref='icon' style="margin-top:6px">event</v-icon>
                    <v-date-picker header-color='primary' v-model='dateCalendar' locale='th' :readonly='setDisabled' type="month"></v-date-picker>
                </v-menu>
            </v-flex>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
  name: 'GlobalMonth',
  props: {    
    value:0, 
    label: {
      default : ""
    },
    disabled:{
      default:false
    }
  },
  data() {
    return {
      date: null,
      dateFormat: null,
      menu: false
    };
  },
  created() {
    this.setDate()
  },
  computed:{
    setDisabled: {
      get: function() {
        return this.disabled;
      },
      set: function() {}
    },
    dateText:{      
      get: function () {
        // return this.dateFormat
        if (this.dateFormat.length == 6) {
          return this.formatDateThai(this.dateFormat)
        } else {
          return this.dateFormat
        }
      },
      set: function (newVal) { 
        if (newVal) {
          this.dateFormat = newVal
          this.date = this.parseDate(this.dateFormat)
          this.$emit('update:value',this.formatToYYYYMMDD(this.dateFormat))
        } else {
          this.dateFormat=null
          this.date = null
          this.$emit('update:value',0)
        }
      }
    },
    dateCalendar:{
      get: function () {
        return this.date
      },
      set: function (newVal) {
        this.menu = false
        this.date=newVal
        this.dateFormat = this.formatDate(this.date)
        this.$emit('update:value',this.formatToYYYYMMDD(this.dateFormat))
      }
    }
  },
  watch: { 
    value: function(newVal, oldVal) {
      if (newVal) {
        if (newVal && this.dateFormat==null){
        //   this.dateText = this.formatToDDMMYYYY(newVal)
          this.dateText = this.formatDateThai(newVal)
        } else if (this.dateFormat.length==8)  {
        //   this.dateText = this.formatToDDMMYYYY(newVal)
            this.dateText = this.formatDateThai(newVal)
        } 
      } else {this.dateText = null}
    }
  },
  methods: {
    setDate(){
      if (this.value == 0 ) return
      let dateValue = this.value.substring(0,6)
      this.date = this.formatToDDMMYYYY(dateValue)
    //   this.dateText = this.formatToDDMMYYYY(this.date)
      this.dateText = this.date
      // this.dateText = this.formatDateThai(this.date)
    },
    formatDate(date) {
      if (!date) return null;

      let [year, month] = date.split('-');
      return `${month ? month.padStart(2, '0') : '00'}${String(Number(year) + 543).padStart(4, '0')}`;
    },
    parseDate(date) {
      if (!date) return;
      if (date.length != 6) return;
      let [month, year] = [
        date.substring(0, 2),
        Number(date.substring(2, 6))
      ];
      let dates = '';
      let [y, m] = this.getDayMonthYearForZeroPad(month, year);
      dates = `${y}-${m}`;
      return dates;
    },
    formatToDDMMYYYY(date) {
      let data = `${date.toString().padEnd(6, '0')}`;      
      // let data = date
      let [year, month] = [
        data.substring(0,4),
        data.substring(4, 6)
      ];
      return `${month}${year}`;
    },
    formatToYYYYMMDD(date) {
      let data = `${date.toString().padEnd(6, '0')}`;
      let [year, month] = [
        // data.substring(4),
        // data.substring(2, 4)
        data.substring(2, 6),
        data.substring(0, 2)
      ];
      return `${year}${month}`;
    },
    formatDateThai(date) {
      date = date + ''
      let month = date.substring(0,2)
      let year = date.substring(2,6)
      let monthThai = ''
      switch (month) {
        case '01':
          monthThai = 'มกราคม'
          break
        case '02':
          monthThai = 'กุมภาพันธ์'
          break
        case '03':
          monthThai = 'มีนาคม'
          break
        case '04':
          monthThai = 'เมษายน'
          break
        case '05':
          monthThai = 'พฤษภาคม'
          break
        case '06':
          monthThai = 'มิถุนายน'
          break
        case '07':
          monthThai = 'กรกฎาคม'
          break
        case '08':
          monthThai = 'สิงหาคม'
          break
        case '09':
          monthThai = 'กันยายน'
          break
        case '10':
          monthThai = 'ตุลาคม'
          break
        case '11':
          monthThai = 'พฤศจิกายน'
          break
        case '12':
          monthThai = 'ธันวาคม'
          break
      }
      let returnDate = monthThai + ' ' + year
      return returnDate
    },
    getDayMonthYearForZeroPad(month, year) {
      let y = String(Math.abs(year - 543)).padStart(4, '0');
      let m = Number(month) ? `${month.padStart(2, '0')}` : '00';
      return [y, m];
    }
  }
};
</script>

<style>
.v-date-picker-table {
    height: auto;    
}
</style>

<style scoped>
  .text-no-border >>> .v-input__slot:before,
  .text-no-border >>> .v-input__slot:after,
  .text-no-border >>> input {
    border-style: none;
    margin-bottom:0px;
  }
</style>
